import React     from 'react'
import PropTypes from 'prop-types'

import { translateBool, formatDate        } from 'alto-utils/lib/utils'
import { AdminForm, AdminTable, AdminPage } from 'alto-react-components/lib/components'
import CanteenRepository, { Order }         from 'alto-react-canteen/lib/models'

class OrderTable extends AdminTable
  @contextTypes = { backend: PropTypes.object }

  model:       Order
  allowCreate: false

  constructor: (props, context) ->
    super(props, context)

    @state.courses         = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam jídel'

    CanteenRepository.forBackend(context.backend).courses.orderBy('orderNumber').all()
      .then (courses) => @setState({ courses, ready: true })

  columns: ->
    courseOptions = @state.courses.map (course) -> [course.displayName, course.displayName]

    [{
       _property: 'client.firstname'
       property: (order) -> order.associations.client.firstname
       header:
         label: 'Jméno klienta'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       _property: 'client.surname'
       property: (order) -> order.associations.client.surname
       header:
         label: 'Příjmení klienta'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       _property: 'client.clientId'
       property: (order) -> order.associations.client.clientId
       header:
         label: 'Číslo klienta'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       _property: 'meal.name'
       property: (order) -> order.associations.meal.name
       header:
         label: 'Jídlo'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       _property: 'meal.date'
       property: (order) -> order.associations.meal.date
       header:
         label: 'Na'
         formatters: [@orderableAndFilterable(type: 'date')]
       cell:
         formatters: [(moment) -> moment.format('D.M.YYYY')]
       filter:
         matcher: 'exact'
     }, {
       _property: 'meal.course.displayName'
       property: (order) -> order.associations.meal.associations.course.displayName
       header:
         label: 'Chod'
         formatters: [@orderableAndFilterable(type: 'select', options: courseOptions)]
       filter:
         matcher: 'icontains'
     }, {
       property: 'ordered'
       header:
         label: 'Objednáno'
         formatters: [@orderable]
       filter:
         matcher: 'icontains'
     }, {
       property: 'eaten'
       header:
         label: 'Zkonzumováno'
         formatters: [@orderable]
       filter:
         matcher: 'icontains'
     }, {
       property: 'createdAt'
       header:
         label: 'Vytvořena'
         formatters: [@orderable]
       cell:
         formatters: [(moment) -> moment.format('D.M.YYYY H:mm')]
       filter:
         matcher: 'icontains'
     }, {
       property: 'updatedAt'
       header:
         label: 'Aktualizována'
         formatters: [@orderable]
       cell:
         formatters: [(moment) -> moment.format('D.M.YYYY H:mm')]
       filter:
         matcher: 'icontains'
     }]

class OrderForm extends AdminForm
  @contextTypes = { backend: PropTypes.object }

  model: Order

  constructor: (props, context) ->
    super(props, context)

    @state.meals           = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam jídel'

    currentMeal = @props.record.associations.meal

    CanteenRepository.forBackend(context.backend).meals.with('canteen')
      .orderBy('canteenID', 'number')
      .where(date: formatDate(currentMeal.date), courseName: currentMeal.courseName)
      .then (meals) => @setState({ meals, ready: true })

  inputs: ->
    [{
       type:      'static'
       label:     'Klient'
       property:  'clientID'
       formatter: (id, order) ->
         client = order.associations.client
         "#{client.fullName} (#{client.clientId})"
     }, {
       type:      'select'
       label:     'Jídlo'
       property:  'mealID'
       options:   @state.meals.map (meal) -> ["#{meal.name} (#{meal.associations.canteen.name})", meal.id]
     }, {
       label:     'Objednáno'
       property:  'ordered'
       type:      'integer'
       validator: 'notEmpty'
       allowZero: true
     }, {
       label:     'Zkonzumováno'
       property:  'eaten'
       type:      'integer'
       validator: 'notEmpty'
       allowZero: true
     }]

export default class OrderManagement extends AdminPage
  @contextTypes = { backend: PropTypes.object }

  tableComponent: OrderTable
  formComponent:  OrderForm

  relation: ->
    @__relation ?= CanteenRepository.forBackend(@context.backend).orders.with('client', 'meal', 'meal.course')
